import { logger } from "./logger";

const LIMIT_DEFAULT = 3;
const BACKOFF_MS_DEFAULT = 1000;

export namespace retry {
	export type Fn<T> = () => T;

	export type Options = {
		limit?: number;
		backoffMs?: number;
	};
}

export function retry<T>(fn: retry.Fn<T>): T;
export function retry<T>(config: retry.Options, fn: retry.Fn<T>): T;

export async function retry<T>(
	...args: [retry.Fn<T>] | [retry.Options, retry.Fn<T>]
): Promise<T | Error> {
	const [fn, config] =
		args.length === 1 ? [args[0], undefined] : [args[1], args[0]];

	let count = 0;
	const limit = config?.limit ?? LIMIT_DEFAULT;
	const backoffMs = config?.backoffMs ?? BACKOFF_MS_DEFAULT;

	let response = await fn();
	while (count < limit) {
		count++;
		if (response instanceof Error) {
			await delay(count * backoffMs);
		} else {
			break;
		}
		logger.debug("retry: attempt", { count, limit });
		response = await fn();
	}
	return response;
}

function delay(timeoutMs: number) {
	return new Promise((resolve) => setTimeout(resolve, timeoutMs));
}
